import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { closeAlert } from '@redux/app/appSlice';
import { useTranslation } from 'react-i18next';
import { SuccessFilled, NoticeFilled } from '@assets';

const Modal = styled(AntModal)`

.ant-modal-title {
    text-align: center;
    color: ${props => props.theme.primaryColor};
    text-transform: capitalize;
}

.ant-modal-body {
    padding: 8px 0;
    text-align: center;
    color: ${props => props.status === 'error' ? 'red' : '#000'};
    white-space: pre-line;
}

.ant-modal-footer {
    text-align: center;

    .ant-btn {
        min-width: 76px;
    }

    .ant-btn-default {
        display: none !important;
    }
}
`;

const Alert = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { open, message, isError, successCallback } = useSelector(state => state.app.alert);

    const handleClose = () => dispatch(closeAlert());

    const onOk = () => {
        successCallback && successCallback();
        handleClose();
    }

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            width={320}
            open={open}
            onOk={onOk}
            title={isError ? t('common.notice') : t('common.success')}
            okText={t('common.ok')}
            status={isError ? 'error' : 'success'}
        >
            {isError ? <NoticeFilled id='modal-icon' /> : <SuccessFilled id='modal-icon' />}
            {message}
        </Modal>
    );
}

export default Alert;